import React, { useState, useEffect } from "react";

import styled from "styled-components";
import PretendardText from "../../atoms/text/pretendardText";
import Checkbox from "../../atoms/checkbox/checkbox";
import useDisplay from "../../../hooks/useDisplay";
import LSRgBody01 from "../text/linSeedKr/Rg/lsRgBody01";
import LSRgCaption02 from "../text/linSeedKr/Rg/lsRgCaption02";

function RightLabelCheckbox({
  text,
  size,
  checked,
  onChange,
  inputStyle,
  textStyle,
}) {
  const { isMobile, isTablet, isDesktop } = useDisplay();

  const isSmall = isMobile || isTablet;

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          cursor: "pointer",
          ...inputStyle,
        }}
      >
        <Checkbox onChange={onChange} checked={checked} size={size} />

        {isDesktop && (
          <StyledP
            onClick={onChange}
            style={{
              ...textStyle,
            }}
          >
            {text}
          </StyledP>
        )}

        {isSmall && (
          <StyledPMobile
            onClick={onChange}
            style={{
              ...textStyle,
            }}
          >
            {text}
          </StyledPMobile>
        )}
      </div>
    </>
  );
}

export default RightLabelCheckbox;

const StyledP = styled(LSRgBody01)`
  color: #404249;

  flex: 1;
  margin-left: 8px;
`;

const StyledPMobile = styled(LSRgCaption02)`
  color: #404249;

  flex: 1;
  margin-left: 8px;
`;
